import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Eye, Package } from '@phosphor-icons/react';
import { CATEGORY_LABELS, CONDITION_LABELS, CONDITION_COLORS, photoUrl, formatPrice } from '../utils/marketplace';

export const MarketplaceCard = ({ listing }) => (
  <Link
    to={`/marketplace/listing/${listing._id}`}
    className="group bg-white dark:bg-neutral-800 border-2 border-black rounded-xl overflow-hidden shadow-[4px_4px_0px_#000] hover:-translate-y-1 transition-transform"
    data-testid={`marketplace-card-${listing._id}`}
  >
    <div className="relative aspect-square bg-neutral-100 dark:bg-neutral-900">
      {listing.photos?.length > 0 ? (
        <img src={photoUrl(listing.photos[0])} alt={listing.title} loading="lazy" className="w-full h-full object-cover" />
      ) : (
        <div className="w-full h-full flex items-center justify-center">
          <Package size={48} weight="duotone" className="text-neutral-300 dark:text-neutral-600" />
        </div>
      )}
      <span className={`absolute top-2 left-2 ${CONDITION_COLORS[listing.condition] || 'bg-neutral-500'} text-white text-[10px] font-black uppercase px-2 py-0.5 border border-black rounded`}>
        {CONDITION_LABELS[listing.condition] || listing.condition}
      </span>
      {listing.status === 'sold' && (
        <div className="absolute inset-0 bg-black/60 flex items-center justify-center">
          <span className="bg-red-600 text-white font-black uppercase text-lg px-4 py-1 border-2 border-black -rotate-6">Sold</span>
        </div>
      )}
    </div>
    <div className="p-3">
      <p className="text-lg font-black text-neutral-900 dark:text-white">
        {formatPrice(listing.price)}
        {listing.negotiable && <span className="text-[10px] font-bold text-[#D95800] uppercase ml-1.5">OBO</span>}
      </p>
      <p className="text-sm font-bold text-neutral-700 dark:text-neutral-300 truncate group-hover:text-[#D95800] transition-colors">{listing.title}</p>
      <div className="flex items-center justify-between mt-1.5">
        <p className="text-xs text-neutral-500 flex items-center gap-1 truncate">
          <MapPin size={12} weight="bold" /> {listing.city}, {listing.state}
        </p>
        <p className="text-[10px] text-neutral-400 flex items-center gap-1 shrink-0">
          <Eye size={11} weight="bold" /> {listing.views || 0}
        </p>
      </div>
      <p className="text-[10px] font-bold uppercase text-neutral-400 mt-1">{CATEGORY_LABELS[listing.category] || listing.category}</p>
    </div>
  </Link>
);
